type SubmissionStage = 'preparing' | 'session' | 'draft' | 'completion';

// Do not log raw API messages: validation errors can contain submitted values.
const descriptions: Record<string, string> = {
  INVALID_EMAIL: 'The prospect email failed validation.',
  INVALID_REQUEST: 'The request failed validation.',
  INVALID_RESPONSES: 'The response data failed validation.',
  INVALID_TOKEN: 'The session token is invalid, expired, or does not match the attempt.',
  UNAUTHORIZED: 'The request was not authorized.',
  NOT_FOUND: 'The requested quiz was not found.',
  QUIZ_NOT_PUBLISHED: 'The quiz does not have a published version.',
  QUIZ_VERSION_CHANGED: 'The published quiz version changed during the attempt.',
  ATTEMPT_SCOPE_MISMATCH: 'The attempt belongs to a different quiz, tenant, or prospect.',
  ATTEMPT_NOT_IN_PROGRESS: 'The assessment attempt is no longer in progress.',
  PERSISTENCE_UNAVAILABLE: 'Assessment persistence or validation is unavailable.',
  BRANCHING_RULES_UNAVAILABLE: 'The quiz branching rules could not be loaded.',
  SCORING_DATA_UNAVAILABLE: 'The quiz scoring data could not be loaded.',
};

export function getSubmissionFailure(error: unknown, fallbackStage: SubmissionStage) {
  const failure = error as {
    response?: { status?: unknown; data?: { error?: { code?: unknown } } };
    config?: { url?: unknown };
  } | null;
  const url = failure?.config?.url;
  const stage: SubmissionStage = typeof url === 'string' && url.endsWith('/session') ? 'session'
    : typeof url === 'string' && url.endsWith('/draft') ? 'draft' : fallbackStage;
  const rawStatus = failure?.response?.status;
  const status = typeof rawStatus === 'number' && Number.isInteger(rawStatus) && rawStatus >= 100 && rawStatus <= 599
    ? rawStatus : undefined;
  const rawCode = failure?.response?.data?.error?.code;
  const code = typeof rawCode === 'string' && Object.prototype.hasOwnProperty.call(descriptions, rawCode) ? rawCode : undefined;
  const invalidEmail = code === 'INVALID_EMAIL'
    || (error instanceof Error && error.message === 'Enter a valid prospect email before completing this saved attempt.');

  return {
    stage,
    status,
    code,
    description: invalidEmail ? descriptions.INVALID_EMAIL
      : code ? descriptions[code] : 'The submission failed for an unspecified reason.',
    message: 'Failed to submit quiz. Please retry. If the problem continues, contact support. Your answers are still here.',
  };
}